"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useIdentity } from "@/hooks/useIdentity";
import { useParams } from "next/navigation";
import { useContext } from "react";
import UserPageDrops from "./UserPageDrops";
export default function UserPageBrainWrapper(t0) {
  const $ = _c(8);
  const {
    profile: initialProfile
  } = t0;
  const params = useParams();
  const t1 = params.user as string;
  let t2;
  if ($[0] !== t1) {
    t2 = t1.toLowerCase();
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const user = t2;
  const {
    showWaves
  } = useContext(AuthContext);
  let t3;
  if ($[2] !== initialProfile || $[3] !== user) {
    t3 = {
      handleOrWallet: user,
      initialProfile
    };
    $[2] = initialProfile;
    $[3] = user;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    profile
  } = useIdentity(t3);
  if (!showWaves) {
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="tw-min-h-screen" />;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  const t4 = profile ?? initialProfile;
  let t5;
  if ($[6] !== t4) {
    t5 = <UserPageDrops profile={t4} />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}